import React from 'react'

import Hero from '../Hero/Hero';
import Presentation from '../Presentation/Presentation';
import Blog2 from '../Blog2/Blog2';
// import Slider1 from '../Slider1/Slider1';
import Footer from '../Footer/Footer';
 import Carousel1 from '../Carousel1/Carousel1';
import Process2 from '../../Process2/Process2';
// import Events from '../Events/Events';








const Home = () => {
    console.log ( `react snippet works!` );

    return (
        
        <><link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.2/font/bootstrap-icons.css" rel="stylesheet"/>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js"></script>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet"/>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css" />
       <Hero/>
      <Process2/>
     
       
      
       <Blog2/>
       <Presentation/>
       {/* <Events/> */}
         <Carousel1/>  
        
     {/* <Slider1/> */}
       <Footer/>
           
        </>
    );
}

export default Home;